import { RootState } from "../../redux-store";
import { createSelector } from "@reduxjs/toolkit";
import { selectFeature } from "../features/selectors";

export const selectStatus = (state: RootState) => state.auth.status;

export const selectLanguage = (state: RootState) =>
  state.auth.me?.defaultLanguage || "da";

export const selectMe = (state: RootState) => state.auth.me;

export const selectDefaultSearchLocation = createSelector(selectMe, (me) => {
  return me?.searchOriginLocation || { lat: 48.2082, lon: 16.3738 }; // Vienna, originally from PlaceSearch.tsx
});

export const selectDefaultCargoType = createSelector(
  selectMe,
  (me) => me?.defaultCargoType || null
);

export const selectShouldShowCompleteStopButton = createSelector(
  selectMe,
  (me) => !me?.collectedDeliveredButtonsRemovedForOrg
);

export const selectClientRequiredOnCargos = createSelector(
  selectMe,
  (me) => !!me?.clientRequiredOnCargos
);

export const selectShouldShowEditCargoButtons = (state: RootState) => {
  const featureEnabled = selectFeature("driver-update-cargo")(state);
  return featureEnabled && state.auth.me?.canEditCargos;
};

export const selectShouldShowAddProductButton = (state: RootState) => {
  const featureEnabled = selectFeature("driver-add-invoice-lines")(state);
  return featureEnabled && state.auth.me?.canAddInvoiceLines;
};
